import React from 'react'
import PropTypes from 'prop-types'
import { Box, CircularProgress } from '@mui/material'

export const InfiniteScrollSentinel = ({
  sentinelRef,
  loadingMore,
  hasMore,
}) => {
  if (!hasMore && !loadingMore) return null

  return (
    <Box
      ref={sentinelRef}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        py: 2,
        minHeight: 48,
      }}
      aria-live='polite'
      aria-busy={loadingMore}
    >
      {loadingMore ? (
        <CircularProgress size={28} aria-label='Loading more results' />
      ) : null}
    </Box>
  )
}

InfiniteScrollSentinel.propTypes = {
  sentinelRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  loadingMore: PropTypes.bool,
  hasMore: PropTypes.bool,
}

export default InfiniteScrollSentinel
